import { AppLanguage, IAppConfig } from '@tnq/shared/types';
import { AdminRole } from '@tnq/shared/core';

export const config: IAppConfig = {
  languageOptions: [AppLanguage.Dutch],
  portal: 'navigation.admin_portal',
  navList: [
    {
      label: 'navigation.users',
      link: 'admins',
      icon: 'profile',
    },
    {
      label: 'navigation.customers',
      link: 'customers',
      icon: 'users',
    },
    {
      label: 'navigation.customer_groups',
      link: 'customer-groups',
      icon: 'users-group',
    },
    {
      label: 'navigation.discounts',
      link: 'kortingen',
      icon: 'pig-money',
    },
    {
      label: 'navigation.station_groups',
      link: 'station-groups',
      icon: 'gas-station',
      roles: [AdminRole.SuperAdmin],
    },
    {
      label: 'navigation.audit_log',
      link: 'audit-log',
      icon: 'address-book',
      roles: [AdminRole.SuperAdmin],
    },
  ],
};
